/** `POST /api/split_property` may return a bare id or an object — normalize for wizard state. */
export function normalizeSplitPropertyId(response: unknown): string {
  if (response == null) return ''
  if (typeof response === 'number') return String(response)
  if (typeof response === 'string') return response.trim()
  if (typeof response === 'object') {
    const row = response as Record<string, unknown>
    const id = row.property_id ?? row.id ?? row.new_property_id
    if (id != null && id !== '') return String(id).trim()
  }
  return String(response).trim()
}
